import axios from 'axios';
import { Constants } from '../utils/constants';
import { generateToken } from './authService';
import { showMessage } from '../utils/alerts';


let sessionFlag = true;
let errorFag = true;



async function retryToken() {
 
  localStorage.setItem('tr', true);
  let token = localStorage.getItem('token');
 

  if (!token) {
   
    token = await generateToken();
    localStorage.setItem("token",token.access_token)
  } 


  return token;
}



const GuestApiAuthenticated = axios.create({
  baseURL: Constants.URL.base,
});

GuestApiAuthenticated.interceptors.request.use(async request => {




  let token = "";


  

  token = await retryToken();


  request.headers['Authorization'] = `Bearer ${token.access_token ? token.access_token :token}`
 

  return request;
});

GuestApiAuthenticated.interceptors.response.use(
  response => {
  
    if (response.status === 200) {
      
      errorFag = true;
      sessionFlag = true;
    }
    return response;
  },
  async error => {
    const status = error.response ? error.response.status : null;
   

    if (status === 500) {
      if (errorFag) {
        showMessage('Something went wrong', 'Please try again later!.');
        errorFag = false;
      }
      return Promise.reject(error);
    }

    if (status === 403) {
      if (errorFag) {
        showMessage('No Permission', 'Your user has no access to this data!.');
        errorFag = false;
      }
      return Promise.reject(error);
    }

    if (status === 404) {
      if (errorFag) {
        showMessage('No Permission', 'Your user has no access to this data!.');
        errorFag = false;
      }
      return Promise.reject(error);
    }

    if (status === 401) {
      if (sessionFlag) {
        showMessage('Session Expired!', 'Please login again.');
        sessionFlag = false;
      }

      // store.dispatch(userActions.logout());
      return Promise.reject(error);
    }

    
    return Promise.reject(error);
  }
);

export { GuestApiAuthenticated };
